import React, { Component } from "react";
import { Divider, Row, Layout } from "antd";
import ReactGA from "react-ga4";
import Obfuscate from "react-obfuscate";
import throttle from "lodash.throttle";
import PropTypes from "prop-types";
import VenatusAd from "../ads/VenatusAd";
import VenatusAdWithPlaceholder from "../ads/VenatusAdWithPlaceholder";
import {
  VENATUS_DESKTOP_LEADERBOARD,
  VENATUS_MOBILE_LEADERBOARD,
  VENATUS_RICH_MEDIA,
} from "../utilities/constants";

const { Content } = Layout;

export const initGA = () => {
  ReactGA.initialize(
    "G-MX6GYDK28N"
    // , {
    //   gaAddress: "https://onestoppress.com/analytics.js"
    // }
  );
};

export const logPageView = () => {
  ReactGA.set({ page: window.location.pathname + window.location.search });
  
};

class FAQ extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewportWidth: 0,
    };
  }
  componentDidMount() {
    this.saveViewportDimensions();
    window.addEventListener("resize", this.saveViewportDimensions);

    // initGA();
    // logPageView();

    document.title = "My Gamatoto FAQ | Battle Cats Wiki for Cat Stats";
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.saveViewportDimensions);
  }

  saveViewportDimensions = throttle(() => {
    let adjustViewport;
    if (window.innerWidth < 636) {
      adjustViewport = 22;
    } else if (window.innerWidth < 948) {
      adjustViewport = 34;
    } else {
      adjustViewport = 46;
    }

    this.setState({
      viewportWidth: window.innerWidth - adjustViewport,
    });
  }, this.props.applyViewportChange);

  showModal = () => {
    this.setState({ isModalVisible: true });
  };

  handleCancel = () => {
    this.setState({ isModalVisible: false });
  };

  render() {
    return (
      <div>
        <div className="pagetitle">
          <h1 style={{ padding: "10px 0 0 0", marginBottom: "6px" }}>About</h1>
          <Divider style={{ margin: "0 0 0 0", padding: "0 0 0 0" }} />
          {this.state.viewportWidth > 1024 ? (
            <VenatusAdWithPlaceholder placementId={VENATUS_DESKTOP_LEADERBOARD} />
          ) : (
            <VenatusAdWithPlaceholder placementId={VENATUS_MOBILE_LEADERBOARD} />
          )}
        </div>
        <Layout style={{ padding: "0 12px 0 12px", background: "white" }}>
          <Content style={{ padding: "0 0px" }}>
            <Row style={{ padding: "16px 0 16px 0" }}>
              <div style={{ textAlign: "center" }}>
                <p></p>Welcome to My Gamatoto!
              </div>
            </Row>
            <Row style={{ padding: "16px 0 16px 0" }}>
              <div style={{ textAlign: "center" }}>
                Feel free to contact me at
                <span>
                  {" "}
                  <Obfuscate
                    email="mygamatoto@gmail.com"
                    headers={{
                      subject: "Question from My Gamatoto",
                    }}
                  />
                </span>{" "}
                if there are any features you'd like to see, or comments you'd
                like to share!
              </div>
            </Row>
            <Row style={{ padding: "16px 0 16px 0" }}>
              <div style={{ textAlign: "center" }}>
                Credit goes to CatBot and BCU for the data and icons for stages
                and enemies.
              </div>
            </Row>
            <Row style={{ padding: "4px 0 0 0" }}></Row>
          </Content>
        </Layout>
        {/* <div
          style={{
            position: "absolute",
            bottom: 0,
            width: "100%",
          }}
        >
          <HorizontalAdPopup
            dataAdClient="ca-pub-1920730948516638"
            dataAdSlot="3648042688"
          ></HorizontalAdPopup>
        </div> */}
        <div>
          <VenatusAd
            placementId={VENATUS_RICH_MEDIA}
            style={{ display: "none" }}
          />
        </div>
      </div>
    );
  }
}

export default FAQ;

FAQ.propTypes = {
  applyViewportChange: PropTypes.number,
};

FAQ.defaultProps = {
  applyViewportChange: 250,
};



// WEBPACK FOOTER //
// ./src/components/content/FAQ.js